import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { Components } from 'Route/routes'
import rootStore from 'Store/createStore'
import { injectReducer } from 'Store/reducers'
import { injectSaga } from 'Store/sagas'
import componentConfig from 'Utility/globalConfig'
import ChatbotWrapper from '../../src/components/Template/ChatbotWrapper'
import PortalLoader from '@nexidigital/portalloader'

export const LazyComponent = (props) => {
  const { componentName, pluginReducer, pluginSaga, hasReducer, hasSaga } = props
  const isChatbotEnabled = componentConfig.chatbot.isEnabled()

  if (pluginReducer === undefined && hasReducer) {
    import(/* webpackChunkName: "[request]" */ `Route/${componentName}/modules/${componentName}Reducers`).then(({ default: reducer }) => {
      if (reducer !== undefined) {
        injectReducer(rootStore, { key: componentName, asyncReducer: reducer })
      }
    })
  }

  if (pluginSaga === undefined && hasSaga) {
    import(/* webpackChunkName: "[request]" */ `Route/${componentName}/modules/${componentName}Sagas`).then(({ default: saga }) => {
      if (saga !== undefined) {
        injectSaga(rootStore, { key: componentName, asyncSaga: saga })
      }
    })
  }

  if (pluginReducer) {
    injectReducer(rootStore, { key: componentName, asyncReducer: pluginReducer })
  }

  if (pluginSaga) {
    injectSaga(rootStore, { key: `${componentName}`, asyncSaga: pluginSaga })
  }

  const Component = Components[componentName]
  return (
    <Suspense fallback={
      <div style={{ height: '100vh' }}>
        <PortalLoader circular centered />
      </div>
    }
    >
      <Component {...props} />
      {isChatbotEnabled && <ChatbotWrapper />}
    </Suspense>
  )
}

LazyComponent.propTypes = {
  componentName: PropTypes.string.isRequired,
  pluginReducer: PropTypes.func,
  pluginSaga: PropTypes.func,
  hasReducer: PropTypes.bool,
  hasSaga: PropTypes.bool
}

LazyComponent.defaultProps = {
  pluginReducer: undefined,
  pluginSaga: undefined,
  hasReducer: false,
  hasSaga: false
}

export default LazyComponent
